// extracted by mini-css-extract-plugin
export default {"zoomModal":"r4-z","image":"s4-z","button":"t4-z","isOverlayShown":"u4-z"};